import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Services.css';

// ✏️ PLACEHOLDER: Update service titles, descriptions, and icons as needed
const SERVICES = [
  {
    icon: '✏️',
    name: 'Logo Design',
    description: 'Logos That Speak for Your Brand',
    category: 'Logo Design' // Maps to portfolio category
  },
  {
    icon: '🖥️',
    name: 'Web UI/UX Design',
    description: 'Modern, Fast & Conversion-Focused Websites',
    category: 'Website Design'
  },
  {
    icon: '📱',
    name: 'App Design',
    description: 'Designing Apps Users Love',
    category: 'Application Design'
  },
  {
    icon: '🎬',
    name: 'Logo Reveal',
    description: 'Animated First Impressions That Last',
    category: 'Logo Design'
  },
  {
    icon: '🎞️',
    name: 'Motion Graphics',
    description: 'Dynamic Motion for Modern Brands',
    category: 'Animation Video'
  },
  {
    icon: '📹',
    name: 'Marketing Videos',
    description: 'Turning Views Into Results',
    category: 'Marketing Video'
  },
];

export default function Services() {
  const navigate = useNavigate();

  const handleServiceClick = (category) => {
    // Navigate to portfolio page with the category as state
    navigate('/portfolio-work', { 
      state: { selectedCategory: category } 
    });
  };

  return (
    <section className="services section" id="services">
      <div className="container">
        <div className="text-center">
          <span className="section-label">What I Do</span>
          <h2 className="section-title">Services</h2>
          <div className="divider" />
        </div>

        <div className="services-grid">
          {SERVICES.map((service) => (
            <div 
              className="service-card" 
              key={service.name}
              onClick={() => handleServiceClick(service.category)}
              style={{ cursor: 'pointer' }}
              role="button"
              tabIndex={0}
              onKeyPress={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  handleServiceClick(service.category);
                }
              }}
            >
              <div className="service-icon">{service.icon}</div>
              <h3 className="service-name">{service.name}</h3>
              <p className="service-desc">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}